import { render, staticRenderFns } from "./ApprovalPerformance.vue?vue&type=template&id=e533b8a4&scoped=true"
import script from "./ApprovalPerformance.vue?vue&type=script&lang=js"
export * from "./ApprovalPerformance.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPerformance.vue?vue&type=style&index=0&id=e533b8a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e533b8a4",
  null
  
)

export default component.exports